import React, { useMemo, useState } from "react";
import "../scss/button.scss";
import "../scss/FundsCongratulations.scss";
import { ReactComponent as CheckGreen } from "../images/check-green.svg";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import PageHeader from "../components/PageHeader";
//import { useGetBasicDetailsMutation } from "../lib/services/eligibilityApi";
import { useLocation, useNavigate } from "react-router-dom";
import CenteredPopup from "../components/popups/CenteredPopup";
import { ReactComponent as WarningIcon } from '../images/warning-icon.svg'
import { useSkipPageMutation } from "../lib/services/businessApi";
import { useTapClickMutation } from "../lib/middleware/TapClickApi";
import { pushCleverTapEvent } from "../lib/middleware/CtEvents";


function NewEnachCongratulations() {

  //const [getBasicDetails] = useGetBasicDetailsMutation();
  const [skipPage, { isLoading: skippingPage }] = useSkipPageMutation()
  const location = useLocation();
  const navigate = useNavigate();
  const [tapClick] = useTapClickMutation()
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search])
  const jwt = useMemo(() => queryParams.get('jwt_token'), [queryParams]);
  const secret = useMemo(() => queryParams.get('secret'), [queryParams]);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalopen] = useState(false)

  const handleSkip = async () => {
    pushCleverTapEvent({ event_name: 'web_setup_autopay', event_property: { Source: window.localStorage.getItem('utm_source'), segment: window.localStorage.getItem('customerSegment') === "A3-A6" ? "Non STP" : "STP" } })
    try {
      let jwt_token
      if (jwt) {
        jwt_token = jwt
        localStorage.setItem('jwt', jwt)
      } else {
        jwt_token = localStorage.getItem('jwt')
      }
      const scrt = secret ? secret : localStorage.getItem('secret')
      const result = await skipPage({ jwt_token, scrt, page: 'funds-congratulations' })
      if ((result.data && (result.data.status === 'error' || result.data.status === false)) || (result && result.status === 'error')) {
        setError(result.data.message || 'Some error occured. Please try again.')
        //handleOpen()
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        }
      } else if (result.data && result.data.http_code === 201) {
        if (result.data.message === 'Login expired! Please re-login.') {
          setError(result.data.message)
          //handleOpen()
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          localStorage.clear()
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
          
        } else {
          setError(result.data.message)
          //handleOpen()
        }
      } else if (result.error) {
        setError('Please check your internet or try again later.')
        //handleOpen()
      } else {
        if (result && result.data && result.data.redirect_url) {
          //await getBasicDetailsAPI()
          window.location.href = result.data.redirect_url
        }
      }
    } catch (error) {
      setError('Something went wrong. Please try again later.')
    }
  }

  /*const getBasicDetailsAPI = async () => {
    try {
      let jwt_token
      if (jwt) {
        jwt_token = jwt
        localStorage.setItem('jwt', jwt)
      } else {
        jwt_token = localStorage.getItem('jwt')
      }
      const scrt = secret ? secret : localStorage.getItem('secret')
      const result = await getBasicDetails({ jwt_token, scrt, pan_number: 'ACXPM5858R' })
      if (result.data && result.data.status === 'error') {
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone');
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
        }
      } else if (result.data && result.data.http_code === '201') {
        if (result.data.message === 'Login expired! Please re-login.') {
          localStorage.removeItem('jwt');
          localStorage.removeItem('lastVisitedPage');
          const phone = localStorage.getItem('phone')
          phone ? navigate(`/?phone=${phone}`) : navigate('/');
        }
      } else {
        if (result.error) {
          setError('Something went wrong. Please try again later.');
          setIsModalopen(true)
        } else {
          window.location.href = result.data.redirect_url;
        }
      }
    } catch (error) {
      setError('Something went wrong. Please try again later.');
      setIsModalopen(true)
    }
  }*/

  const handleClose = () => {
    setIsModalopen(false);
    setError('');
  }

  const errorModalButtons = [
    { label: 'Close', onClick: handleClose }
  ]

  return (
    <div className="congratulations-page-container">
      <CenteredPopup
        isOpen={isModalOpen}
        buttons={errorModalButtons}
        onClose={handleClose} icon={<WarningIcon />}>
        <p>{error}</p>
      </CenteredPopup>
      <PageHeader />
      <div className="congratulations">
        <div className="checkmark-container">
          <div className="checkmark-circle">
            <CheckGreen className="checkmark-icon" />
          </div>
        </div>
        <h1 className="title">Congratulations!</h1>
        <p className="subtitle">Your funds are ready!</p>
        <div className="amount-container">
          <p className="amount-label">Loan amount up to</p>
          <p className="amount">₹ 2,00,000</p>
        </div>
      </div>
      <div className="bottom-footer">
        <p className="powered-by">
          {" "}
          Powered by <StarfinLogo />{" "}
        </p>
        <button
          type="submit"
          className={`btn btn-primary ${skippingPage ? 'disabled' : ''}`}
          onClick={handleSkip}
        >
          Continue
        </button>
      </div>

    </div>

  );
}

export default NewEnachCongratulations;
